import { isEqual } from 'lodash';

import { createPersistanceStore } from './createStore';

type HeroVideoState = {
  heroVideoMotionPreference: 'paused' | 'playing' | null;
};

const initialHeroVideoState: HeroVideoState = {
  heroVideoMotionPreference: null,
};

const heroVideoStore = createPersistanceStore<HeroVideoState>(
  initialHeroVideoState,
  `@gapcommerce/heroVideoMotion/${
    process?.env?.NEXT_PUBLIC_STORE_ID ?? 'default'
  }`,
  process?.env?.NEXT_PUBLIC_STORAGE_VERSION as string,
);

const useHeroVideoStore = (): [
  HeroVideoState,
  (_arg: Partial<HeroVideoState>) => void,
] => {
  const state = heroVideoStore(state => state, isEqual);

  const set = heroVideoStore.setState;

  return [state, set];
};

export type { HeroVideoState };
export { useHeroVideoStore };
